/* empty css              */
import { EventRefsFields } from "./EventRefsFields.js";
import { FormBuilderFormRenderer } from "../../../../FormBuilder/components/FormBuilderFormRenderer/index.js";
import { useEffect, useMemo } from "react";
import { Tabs } from "@therms/atalaya";
import { jsx, jsxs } from "react/jsx-runtime";
import { flatten } from "lodash-es";
import { useFormikContext } from "formik";
//#region src/modules/Events/shared/CreateEventForm/components/EventTabs.tsx
var EventTabs = ({ eventType, onFormErrorStateChange }) => {
	const form = useFormikContext();
	const [showRefs, refsCount] = useMemo(() => {
		return [!!Object.values(eventType.refsConfig || {}).filter((x) => x).length, flatten(Object.values(form.values.refsByType || {})).length];
	}, [eventType, form.values.refsByType]);
	useEffect(() => {
		if (!form.values.infoFormInput) {
			form.setFieldValue("infoFormInput.formId", eventType.formsConfig.infoFormId);
			form.setFieldValue("infoFormInput.fields", {});
		}
	}, [eventType]);
	return /* @__PURE__ */ jsxs(Tabs, {
		initialTabKey: "info",
		fullWidth: true,
		children: [eventType.formsConfig.useInfoForm && !!eventType.formsConfig.infoFormId && /* @__PURE__ */ jsx(Tabs.Tab, {
			tabKey: "info",
			title: "Info",
			children: /* @__PURE__ */ jsx("div", {
				className: "event-tab-container",
				children: /* @__PURE__ */ jsx(FormBuilderFormRenderer, {
					formId: eventType.formsConfig.infoFormId,
					initialValue: form.values.infoFormInput?.fields,
					formValues: form.values.infoFormInput?.fields,
					onFormErrorStateChange,
					onFormInputChange: (value) => form.setFieldValue("infoFormInput", value)
				})
			})
		}), showRefs && /* @__PURE__ */ jsx(Tabs.Tab, {
			notifications: refsCount,
			tabKey: "refs",
			title: "Refs",
			children: /* @__PURE__ */ jsx("div", {
				className: "event-tab-container",
				children: /* @__PURE__ */ jsx(EventRefsFields, {
					allowedRefs: eventType.refsConfig,
					onChangeValue: (value) => form.setFieldValue("refsByType", value),
					value: form.values.refsByType
				})
			})
		})]
	});
};
//#endregion
export { EventTabs };

//# sourceMappingURL=EventTabs.js.map